<div>
    <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Gif-Logo2.gif" alt="gif">
</div>